<div class="form-field-label">
  <span [class.required-label]="isFormControlRequired()">{{ label | transloco }}</span>
</div>

<lib-date-time-field [formControl]="control" [stepMinute]="stepMinute" [ngClass]="{ disabled }">
  @if (control.invalid) {
    <mat-error>
      @if (control.errors?.required) {
        {{ 'form.error.required' | transloco }}
      }
      @if (control.errors?.datesRange) {
        {{ 'form.error.dates_range' | transloco }}
      }
    </mat-error>
  }
</lib-date-time-field>
